import { createButton, ViewProps } from "../Button";
import { ButtonColorSchemes, ButtonFlag, ButtonVariants } from "../Enums";

const createHighContrastButton = (name: string, props?: Partial<ViewProps>) =>
    createButton(name, {
        ...props,
        colorScheme: ButtonColorSchemes.Contrast,
        variant: ButtonVariants.Ghost, //NOTE: there is no other variants where contrast color scheme is implemented
    });

/** High contrast transparent button with white text */
export const ButtonContrast = createHighContrastButton("ButtonContrast");

export const ButtonContrastIcon = createHighContrastButton("ButtonContrastIcon", {
    flags: [ButtonFlag.With_icon, ButtonFlag.Small],
    showTooltip: true,
});
